import { Component, Input, OnInit } from '@angular/core';
import { BindingContext } from '../../../../shared/models/BindingContext';

import { HttpErrorResponse } from '@angular/common/http';
import { ApprovalsService } from 'app/shared/services/approvals.service';
import { ListInq } from 'app/shared/models/Approvals';
import { DashboardWidget } from '../../dashboard-interface';
import { Router } from '@angular/router';
import { UserAccessService } from 'app/shared/services/user-access.service';

@Component({
	selector: 'app-dashboard-pend-app',
	templateUrl: './dashboard-pend-app.component.html',
	styleUrls: ['./dashboard-pend-app.component.scss'],
	host: { 'class': 'col-md-6 col-lg-4' }
})
export class DashboardPendAppComponent extends DashboardWidget implements OnInit {

	@Input() title: string;
	@Input() color = 'white';
	@Input() url: string;
	@Input() bindingContext: BindingContext;
	public oldestChangeDate: Date;
	public pendingApprovalCnt: number;
	private dashboardError = 'Error loading dashboard item, please contact support.'
	private _permitClick = false;
	public get permitClick(): boolean {
		return this._permitClick;
	}
	public set permitClick(value: boolean) {
		this._permitClick = value;
	}

	constructor(private pendApprSvc: ApprovalsService,
		private router: Router,
		private accessSvc: UserAccessService,
	) {
		super();
		this.SetClickThrough();
	}

	ngOnInit() {
		this.getData();
	}


	private getData() {
		this.bindingContext.beginGet();
		const listInq: ListInq = new ListInq();
		listInq.StartPage = 1;
		listInq.MaxRows = 25;
		this.pendApprSvc.getPendingApprovalAggregate(listInq).subscribe(
			resp => {
				this.pendingApprovalCnt = resp.TotalChanges;
				this.oldestChangeDate = resp.OldestChange;
				this.bindingContext.endGet();
			},
			(response: HttpErrorResponse) => {
				this.bindingContext.endGet();
				this.bindingContext.showAlert(BindingContext.alertType.danger, this.dashboardError, true);
			}

		);
	}

	SetClickThrough() {
		this.accessSvc.GetAccessLevelBySecurableName('APPROVALS', '', null, null, false).then(resp => {
			if (resp > 0) {
				// They have at least read access
				this.permitClick = true;
			}
		});
	}

	onPendApprClick() {
		if (this.permitClick) {
			this.router.navigate(['/approvals/pending']);
		}

	}
}
